import { number, string, table } from "@rocicorp/zero";

export const crew = table("crews")
	.columns({
		id: string(),
		planId: string().from("plan_id"),
		ranking: number(),
		orgId: string().from("org_id"),
	})
	.primaryKey("id");
